module.exports = __webpack_public_path__ + "static/1-4af05e94f317f152e3a8bb9174614e41.jpg";